<template>
  <div class="data-screen">
    <!-- ==================== 中间地图模块 ==================== -->
    <div class="center-map">
      <div class="panel-box">
        <div class="map-content">
          <!-- ==================== 地图头部 (切换按钮) ==================== -->
          <div class="map-header">
            <!-- 地图切换按钮 -->
            <div class="tab-buttons">
              <button class="tab-btn" :class="{ active: currentMap === 'hunan' }" @click="switchMap('hunan')">湖南</button>
              <button class="tab-btn" :class="{ active: currentMap === 'china' }" @click="switchMap('china')">全国</button>
            </div>
          </div>
          
          <!-- ==================== 地图容器 ==================== -->
          <div id="mapChart" class="map-chart"></div>
          
          <!-- ==================== 地图图例 ==================== -->
          <!--<div class="map-legend">
            <div class="legend-item">
              <span class="legend-icon" style="background: #4facfe"></span>
              <span>参赛人数（万）</span>
            </div>
            <div class="legend-item">
              <span class="legend-icon" style="background: #52c41a"></span>
              <span>占比（%）</span>
            </div>
          </div>-->
          
          <!-- ==================== 柱状图容器 ==================== -->
          <div id="barChart" class="bar-chart"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'

export default {
  name: 'CenterMap',
  data() {
    return {
      mapChart: null,           // 地图图表实例
      barChart: null,           // 柱状图图表实例
      currentMap: 'china',      // 当前显示的地图 ('hunan' 或 'china')，默认全国
      currentCityIndex: 0,      // 当前高亮的城市索引
      cityTimer: null,          // 轮播定时器
      mapLoaded: false,         // 地图是否已加载
      pendingSessionData: null, // 待处理的届次数据
      currentSessionData: null, // 当前届次的完整数据
      cityData: [],             // 湖南城市数据（从后端获取）
      chinaData: [],            // 全国省份数据（从后端获取）
      barChartTimer: null,      // 柱状图轮播定时器
      barChartIndex: 0,         // 柱状图当前高亮索引
      mapResizeObserver: null,  // 地图容器尺寸监听器
      barResizeObserver: null   // 柱状图容器尺寸监听器
    }
  },
  mounted() {
    // 使用 $nextTick 确保 DOM 已经渲染完成
    this.$nextTick(() => {
      // 页面加载完成后加载地图数据
      this.loadMapData()
    })
    
    // 订阅届次切换事件
    EventBus.$on('session-changed', this.handleSessionChange)
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.cityTimer) {
      clearInterval(this.cityTimer)
      this.cityTimer = null
    }
    if (this.barChartTimer) {
      clearInterval(this.barChartTimer)
      this.barChartTimer = null
    }
    
    // 清理 ResizeObserver
    if (this.mapResizeObserver) {
      this.mapResizeObserver.disconnect()
      this.mapResizeObserver = null
    }
    if (this.barResizeObserver) {
      this.barResizeObserver.disconnect()
      this.barResizeObserver = null
    }
    
    // 清理 window.resize 事件监听（降级方案）
    window.removeEventListener('resize', this.handleMapResize)
    window.removeEventListener('resize', this.handleBarResize)
    
    // 销毁图表实例
    if (this.mapChart) {
      this.mapChart.dispose()
      this.mapChart = null
    }
    if (this.barChart) {
      this.barChart.dispose()
      this.barChart = null
    }
    
    // 取消订阅届次切换事件
    EventBus.$off('session-changed', this.handleSessionChange)
  },
  methods: {
    /**
     * 处理地图容器尺寸变化
     */
    handleMapResize() {
      if (this.mapChart) {
        this.mapChart.resize()
      }
    },
    
    /**
     * 处理柱状图容器尺寸变化
     */
    handleBarResize() {
      if (this.barChart) {
        this.barChart.resize()
      }
    },
    
    /**
     * 处理届次切换事件
     * @param {Object} payload - 事件载荷 { session: number|string, data: Object }
     */
    handleSessionChange(payload) {
      const { data } = payload
      
      if (!data) {
        console.error('届次数据为空')
        return
      }
      
      // 保存当前届次数据
      this.currentSessionData = data
      
      // 如果地图还没有加载完成，保存数据待后续处理
      if (!this.mapLoaded) {
        console.log('地图未加载完成，保存届次数据待后续处理')
        this.pendingSessionData = data
        return
      }
      
      // 更新湖南城市数据
      this.updateCityData(data)
      
      // 更新全国省份数据
      this.updateChinaData(data)
      
      // 更新柱状图数据
      this.updateBarChart(data)
    },
    
    /**
     * 更新城市数据标注
     * @param {Object} data - 届次数据
     */
    updateCityData(data) {
      if (!data.cityData || !Array.isArray(data.cityData)) {
        console.error('城市数据格式不正确')
        return
      }
      
      // 更新湖南城市数据 - 将字符串转换为数字
      this.cityData = data.cityData.map(city => ({
        name: city.name,
        value: [parseFloat(city.lng), parseFloat(city.lat), parseInt(city.value) || 0]
      }))
      
      // 停止当前轮播（重要：必须先停止）
      if (this.cityTimer) {
        clearInterval(this.cityTimer)
        this.cityTimer = null
      }
      
      // 重置索引
      this.currentCityIndex = 0
      
      // 如果地图实例存在且当前是湖南地图，更新数据
      if (this.mapChart && this.currentMap === 'hunan') {
        try {
          this.mapChart.setOption({
            series: [
              {
                type: 'effectScatter',
                coordinateSystem: 'geo',
                data: this.cityData
              },
              {
                type: 'scatter',
                coordinateSystem: 'geo',
                data: this.cityData
              },
              {
                type: 'scatter',
                coordinateSystem: 'geo',
                data: this.cityData
              }
            ]
          }, { notMerge: false })
          
          console.log('地图数据更新成功')
          
          // 只有在当前是湖南地图时才启动轮播
          this.startCityCarousel()
        } catch (error) {
          console.error('更新地图数据失败:', error)
        }
      }
    },
    
    /**
     * 更新全国省份数据标注
     * @param {Object} data - 届次数据
     */
    updateChinaData(data) {
      if (!data.chinaData || !Array.isArray(data.chinaData)) {
        console.error('全国省份数据格式不正确')
        return
      }
      
      // 更新全国省份数据 - 将字符串转换为数字
      this.chinaData = data.chinaData.map(province => ({
        name: province.name,
        value: [parseFloat(province.lng), parseFloat(province.lat), parseInt(province.value) || 0]
      }))
      
      // 如果地图实例存在且当前是全国地图，更新数据
      if (this.mapChart && this.currentMap === 'china') {
        try {
          this.mapChart.setOption({
            series: [
              {
                type: 'effectScatter',
                coordinateSystem: 'geo',
                data: this.chinaData
              },
              {
                type: 'scatter',
                coordinateSystem: 'geo',
                data: this.chinaData
              },
              {
                type: 'scatter',
                coordinateSystem: 'geo',
                data: this.chinaData
              }
            ]
          }, { notMerge: false })
          
          console.log('全国地图数据更新成功')
          
          // 只有在当前是全国地图时才启动轮播
          this.startCityCarousel()
        } catch (error) {
          console.error('更新全国地图数据失败:', error)
        }
      }
    },
    
    /**
     * 更新柱状图数据
     * @param {Object} data - 届次数据
     */
    updateBarChart(data) {
      // 根据当前地图类型选择数据源
      const barData = this.currentMap === 'hunan' ? data.cityBarData : data.chinaBarData
      
      if (!barData) {
        console.error('柱状图数据格式不正确')
        return
      }
      
      const { cities, participants, percentage } = barData
      
      if (!cities || !participants || !percentage) {
        console.error('柱状图数据字段缺失')
        return
      }
      
      // 如果柱状图实例不存在，先初始化
      if (!this.barChart) {
        this.barChart = this.$echarts.init(document.getElementById('barChart'))
      }
      
      // 将数据转换为数字类型
      const participantsData = participants.map(v => parseFloat(v) || 0)
      const percentageData = percentage.map(v => parseFloat(v) || 0)
      
      // 更新柱状图配置
      const option = {
        xAxis: {
          data: cities
        },
        series: [
          {
            name: '参赛人数（万）',
            data: participantsData
          },
          {
            name: '占比（%）',
            data: percentageData
          }
        ]
      }
      
      // 使用 notMerge: false 来合并配置，只更新数据部分
      this.barChart.setOption(option, { notMerge: false })
      
      // 启动柱状图轮播
      this.startBarChartCarousel()
    },
    
    /**
     * 启动柱状图轮播
     * 每2秒自动高亮下一个城市
     */
    startBarChartCarousel() {
      // 停止之前的轮播，防止叠加
      this.stopBarChartCarousel()
      
      const chartDom = document.getElementById('barChart')
      if (!chartDom) {
        return
      }
      
      const chart = this.$echarts.getInstanceByDom(chartDom)
      if (!chart) {
        return
      }
      
      const option = chart.getOption()
      if (!option || !option.xAxis || !option.xAxis[0] || !option.xAxis[0].data) {
        return
      }
      
      const dataLength = option.xAxis[0].data.length
      if (dataLength === 0) {
        return
      }
      
      // 重置索引
      this.barChartIndex = 0
      
      // 启动定时器
      this.barChartTimer = setInterval(() => {
        // 移动到下一个
        this.barChartIndex = (this.barChartIndex + 1) % dataLength
        
        // 显示提示框
        chart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: this.barChartIndex
        })
      }, 2000)  // 每2秒切换一次
    },
    
    /**
     * 停止柱状图轮播
     */
    stopBarChartCarousel() {
      if (this.barChartTimer) {
        clearInterval(this.barChartTimer)
        this.barChartTimer = null
      }
      
      // 隐藏提示框
      const chartDom = document.getElementById('barChart')
      if (chartDom) {
        const chart = this.$echarts.getInstanceByDom(chartDom)
        if (chart) {
          chart.dispatchAction({
            type: 'hideTip'
          })
        }
      }
    },
    
    /**
     * 异步加载地图 GeoJSON 数据
     */
    async loadMapData() {
      try {
        // 加载湖南省地图
        const hunanResponse = await fetch('/430000.geoJson')
        if (!hunanResponse.ok) {
          throw new Error(`加载湖南地图失败: ${hunanResponse.status}`)
        }
        const hunanJson = await hunanResponse.json()
        
        // 验证 GeoJSON 数据结构
        if (!hunanJson || !hunanJson.features) {
          throw new Error('湖南地图数据格式不正确')
        }
        
        this.$echarts.registerMap('hunan', hunanJson)
        console.log('湖南地图注册成功')
        
        // 加载全国地图
        const chinaResponse = await fetch('/100000.geoJson')
        if (!chinaResponse.ok) {
          throw new Error(`加载全国地图失败: ${chinaResponse.status}`)
        }
        const chinaJson = await chinaResponse.json()
        
        // 验证 GeoJSON 数据结构
        if (!chinaJson || !chinaJson.features) {
          throw new Error('全国地图数据格式不正确')
        }
        
        this.$echarts.registerMap('china', chinaJson)
        console.log('全国地图注册成功')
        
        // 初始化地图和柱状图
        this.initMap()
        this.initBarChart()
        
        // 标记地图已加载
        this.mapLoaded = true
        console.log('地图加载完成')
        
        // 如果有待处理的届次数据，现在处理它
        if (this.pendingSessionData) {
          console.log('处理待处理的届次数据')
          this.currentSessionData = this.pendingSessionData
          this.updateCityData(this.pendingSessionData)
          this.updateChinaData(this.pendingSessionData)
          this.updateBarChart(this.pendingSessionData)
          this.pendingSessionData = null
        } else {
          // 如果有城市数据，启动轮播
          if (this.cityData && this.cityData.length > 0) {
            this.startCityCarousel()
          }
        }
      } catch (error) {
        console.error('加载地图数据失败:', error)
        // 显示友好的错误提示
        this.$toast?.error?.(`地图加载失败: ${error.message}`)
      }
    },
    
    /**
     * 切换地图
     */
    switchMap(mapType) {
      if (this.currentMap === mapType) return
      
      // 停止轮播（重要：必须先停止）
      if (this.cityTimer) {
        clearInterval(this.cityTimer)
        this.cityTimer = null
      }
      
      // 切换地图类型
      this.currentMap = mapType
      this.currentCityIndex = 0
      
      // 重新初始化地图
      this.initMap()
      
      // 如果有当前届次数据，更新柱状图（根据当前地图类型选择对应的数据）
      if (this.currentSessionData) {
        this.updateBarChart(this.currentSessionData)
      }
      
      // 只有在有数据时才重新启动轮播
      const currentData = this.currentMap === 'hunan' ? this.cityData : this.chinaData
      if (currentData && currentData.length > 0) {
        this.startCityCarousel()
      }
    },
    
    /**
     * 初始化地图
     */
    initMap() {
      // 如果图表实例不存在，则创建
      if (!this.mapChart) {
        this.mapChart = this.$echarts.init(document.getElementById('mapChart'))
      }
      
      // 根据当前地图类型选择数据和配置
      const mapData = this.currentMap === 'hunan' ? this.cityData : this.chinaData
      const mapName = this.currentMap
      const zoom = this.currentMap === 'hunan' ? 1.05 : 1.25
      const aspectScale = this.currentMap === 'hunan' ? 0.85 : 0.75
      
      // 如果没有数据，使用空数组
      const safeMapData = mapData && mapData.length > 0 ? mapData : []

      const option = {
        tooltip: {
          trigger: 'item',
          formatter: function(params) {
            // 添加严格的数据验证，防止偶发的 undefined 错误
            if (!params) return ''
            
            if (params.seriesType === 'scatter') {
              // 散点（城市标记）的提示框：显示城市名和参赛人数
              if (params.value && Array.isArray(params.value) && params.value.length >= 3) {
                const count = params.value[2].toLocaleString()
                return params.name + '<br/>参赛人数: ' + count
              } else {
                return params.name || ''
              }
            } else if (params.seriesType === 'map') {
              // 地图区域的提示框：只显示地区名称
              return params.name || ''
            } else {
              return params.name || ''
            }
          },
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#4facfe',
          borderWidth: 1,
          padding: [6, 10],
          textStyle: {
            color: '#fff',
            fontSize: 12
          }
        },
        geo: {
          map: mapName,
          roam: false,
          zoom: zoom,
          aspectScale: aspectScale,
          center: this.currentMap === 'china' ? [105, 36] : undefined,
          itemStyle: {
            areaColor: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: '#0a2239' },
                { offset: 0.5, color: '#0d3a5f' },
                { offset: 1, color: '#1a4d6f' }
              ]
            },
            borderColor: '#00d4ff',
            borderWidth: 1.5,
            shadowColor: 'rgba(0, 212, 255, 0.8)',
            shadowBlur: 30,
            shadowOffsetX: 0,
            shadowOffsetY: 15  // 增加阴影偏移，营造高度感
          },
          emphasis: {
            itemStyle: {
              areaColor: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: '#1a4d6f' },
                  { offset: 0.5, color: '#2a6f9f' },
                  { offset: 1, color: '#3a8fbf' }
                ]
              },
              borderColor: '#4facfe',
              borderWidth: 2.5,
              shadowColor: 'rgba(79, 172, 254, 1)',
              shadowBlur: 40,
              shadowOffsetX: 0,
              shadowOffsetY: 20  // 高亮时增加更多高度感
            },
            label: {
              show: false
            }
          },
          label: {
            show: false
          }
        },
        series: [
          // 涟漪光波效果
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            data: safeMapData,
            rippleEffect: {
              scale: 6,
              brushType: 'stroke'
            },
            showEffectOn: 'render',
            itemStyle: {
              normal: {
                color: '#00FFFF'
              }
            },
            symbol: 'circle',
            symbolSize: [6, 3],
            z: 998,
            tooltip: {
              show: false
            }
          },
          // 底部发光标记
          {
            type: 'scatter',
            coordinateSystem: 'geo',
            data: safeMapData,
            symbol: 'image://' + require('@/assets/image.png'),
            symbolSize: [20, 26],
            symbolOffset: [0, -13],
            z: 999,
            tooltip: {
              show: true
            }
          },
          // 顶部信息框
          {
            type: 'scatter',
            coordinateSystem: 'geo',
            data: safeMapData,
            symbol: 'image://' + require('@/assets/image2.png'),
            symbolSize: [55, 32],
            symbolOffset: [0, -39],
            z: 1000,
            label: {
              show: true,
              formatter: function(params) {
                if (params.value[2] > 0) {
                  const name = params.name.replace('市', '').replace('土家族苗族自治州', '').replace('自治区', '').replace('省', '')
                  return '{fline|' + params.value[2] + '人}\n{tline|' + name + '}'
                } else {
                  return ''
                }
              },
              position: 'inside',
              color: '#fff',
              rich: {
                fline: {
                  padding: [0, 0, 0, 0],
                  color: '#fff',
                  fontSize: 8,
                  fontWeight: 400
                },
                tline: {
                  padding: [0, 0, 0, 0],
                  color: '#ABF8FF',
                  fontSize: 7
                }
              }
            },
            tooltip: {
              show: false
            }
          }
        ]
      }
      
      this.mapChart.setOption(option, true)
      
      // 添加响应式支持：监听地图容器尺寸变化
      const mapDom = document.getElementById('mapChart')
      if (mapDom) {
        // 优先使用 ResizeObserver（现代浏览器支持）
        if (typeof ResizeObserver !== 'undefined') {
          // 如果已存在 observer，先断开
          if (this.mapResizeObserver) {
            this.mapResizeObserver.disconnect()
          }
          
          // 使用防抖避免 ResizeObserver loop 错误
          let resizeTimeout = null
          this.mapResizeObserver = new ResizeObserver(() => {
            if (resizeTimeout) {
              clearTimeout(resizeTimeout)
            }
            resizeTimeout = setTimeout(() => {
              this.handleMapResize()
            }, 100)
          })
          
          this.mapResizeObserver.observe(mapDom)
        } else {
          // 降级方案：使用 window.resize 事件
          window.removeEventListener('resize', this.handleMapResize)
          window.addEventListener('resize', this.handleMapResize)
        }
      }
      
      window.addEventListener('resize', () => {
        if (this.mapChart) {
          this.mapChart.resize()
        }
      })
    },
    
    /**
     * 启动城市数据轮播
     */
    startCityCarousel() {
      // 先清除已存在的定时器，防止叠加
      if (this.cityTimer) {
        clearInterval(this.cityTimer)
        this.cityTimer = null
      }
      
      const currentData = this.currentMap === 'hunan' ? this.cityData : this.chinaData
      
      // 如果没有数据，不启动轮播
      if (!currentData || currentData.length === 0) {
        console.warn('城市数据为空，无法启动轮播')
        return
      }
      
      // 如果地图实例不存在，不启动轮播
      if (!this.mapChart) {
        console.warn('地图实例不存在，无法启动轮播')
        return
      }
      
      this.cityTimer = setInterval(() => {
        // 取消上一个高亮（针对所有 series）
        for (let i = 0; i < 3; i++) {
          this.mapChart.dispatchAction({
            type: 'downplay',
            seriesIndex: i,
            dataIndex: this.currentCityIndex
          })
        }
        
        // 移动到下一个
        this.currentCityIndex = (this.currentCityIndex + 1) % currentData.length
        
        // 高亮当前区域（针对所有 series）
        for (let i = 0; i < 3; i++) {
          this.mapChart.dispatchAction({
            type: 'highlight',
            seriesIndex: i,
            dataIndex: this.currentCityIndex
          })
        }
        
        // 显示提示框（只在第二个 series，即发光标记上显示）
        this.mapChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 1,
          dataIndex: this.currentCityIndex
        })
      }, 3000)
    },
    
    /**
     * 初始化柱状图
     */
    initBarChart() {
      // 如果图表实例不存在，则创建
      if (!this.barChart) {
        this.barChart = this.$echarts.init(document.getElementById('barChart'))
      }
      
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#4facfe',
          borderWidth: 1,
          padding: [3, 5],                      // 缩小内边距
          textStyle: {
            color: '#fff',
            fontSize: 11                        // 缩小字体
          }
        },
        legend: {
          top: '0%',
          left: 'center',
          textStyle: {
            color: 'rgba(255, 255, 255, 0.45)',
            fontSize: 12
          },
          bottom: 0,
          itemWidth: 15,
          itemHeight: 10
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '20%',           // 增加底部边距，给 dataZoom 和旋转标签留空间
          top: '18%',
          containLabel: true
        },
        // 添加数据缩放组件，支持拖动查看
        dataZoom: [
          {
            type: 'slider',        // 滑动条型数据缩放组件
            show: true,
            xAxisIndex: [0],
            start: 0,              // 数据窗口范围的起始百分比（0-100）
            end: 100,               // 数据窗口范围的结束百分比（0-100），默认显示前50%的数据
            height: 20,            // 组件高度
            bottom: 8,             // 距离容器底部的距离
            borderColor: 'rgba(79, 172, 254, 0.3)',
            fillerColor: 'rgba(79, 172, 254, 0.2)',  // 选中范围的填充颜色
            handleStyle: {
              color: '#4facfe',
              borderColor: '#4facfe'
            },
            textStyle: {
              color: '#8c8c8c',
              fontSize: 10
            },
            dataBackground: {
              lineStyle: {
                color: 'rgba(79, 172, 254, 0.3)'
              },
              areaStyle: {
                color: 'rgba(79, 172, 254, 0.1)'
              }
            }
          },
          {
            type: 'inside',        // 内置型数据缩放组件（支持鼠标滚轮和触摸拖动）
            xAxisIndex: [0],
            start: 0,
            end: 50,
            zoomOnMouseWheel: true,  // 开启鼠标滚轮缩放
            moveOnMouseMove: true,   // 开启鼠标拖动平移
            moveOnMouseWheel: false  // 关闭鼠标滚轮平移（避免与缩放冲突）
          }
        ],
        xAxis: {
          type: 'category',
          data: [],  // 从后端获取
          axisLabel: {
            color: '#8c8c8c',
            rotate: 45,              // 旋转 45 度，避免重叠
            fontSize: 11,            // 增大字体从 8 到 11
            interval: 0,             // 强制显示所有标签
            margin: 10,              // 增加标签与轴线的距离
            formatter: function(value) {
              // 简化城市名称，去掉"市"字
              return value.replace('市', '').replace('土家族苗族自治州', '州')
            }
          },
          axisLine: {
            lineStyle: {
              color: '#1f3a4f'
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '',//参赛人数
            nameTextStyle: {
              color: '#8c8c8c',
              fontSize: 12
            },
            axisLabel: {
              color: '#8c8c8c',
              fontSize: 12
            },
            splitLine: {
              lineStyle: {
                color: '#1f3a4f',
                type: 'dashed'
              }
            },
            axisLine: {
              show: false
            }
          },
          {
            type: 'value',
            name: '',//占比
            nameTextStyle: {
              color: '#8c8c8c',
              fontSize: 12
            },
            axisLabel: {
              color: '#8c8c8c',
              formatter: '{value}%',
              fontSize: 12
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '参赛人数（万）',
            type: 'bar',
            data: [],  // 从后端获取
            barWidth: '20%',
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: '#006DFF' },
                  { offset: 0.5, color: '#006DFF' },
                  { offset: 1, color: '#003E92' }
                ]
              },
              borderRadius: [0, 0, 0, 0],
              shadowColor: 'rgba(0, 212, 255, 0.5)',
              shadowBlur: 0
            },
            emphasis: {
              itemStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: '#6dd5ff' },
                    { offset: 0.5, color: '#4facfe' },
                    { offset: 1, color: '#4db6e5' }
                  ]
                },
                shadowColor: 'rgba(79, 172, 254, 0.8)',
                shadowBlur: 0
              }
            }
          },
          {
            name: '占比（%）',
            type: 'bar',
            yAxisIndex: 1,
            data: [],  // 从后端获取
            barWidth: '20%',
            itemStyle: {
              color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: '#6CD48B' },
                    { offset: 0.5, color: '#6CD48B' },
                    { offset: 1, color: '#105C27' }
                  ]
                },
              borderRadius: [0, 0, 0, 0],
              shadowColor: 'rgba(0, 212, 255, 0.5)',
              shadowBlur: 0
            },
            lineStyle: {
              width: 3,
              shadowColor: 'rgba(82, 196, 26, 0.5)',
              shadowBlur: 0
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(82, 196, 26, 0.4)' },
                  { offset: 1, color: 'rgba(82, 196, 26, 0.05)' }
                ]
              }
            },
            emphasis: {
              itemStyle: {
                borderWidth: 3,
                shadowBlur: 0,
                shadowColor: 'rgba(82, 196, 26, 0.8)',
                scale: 1.3
              }
            }
          }
        ]
      }
      this.barChart.setOption(option)
      
      // 添加响应式支持：监听柱状图容器尺寸变化
      const barDom = document.getElementById('barChart')
      if (barDom) {
        // 优先使用 ResizeObserver（现代浏览器支持）
        if (typeof ResizeObserver !== 'undefined') {
          // 如果已存在 observer，先断开
          if (this.barResizeObserver) {
            this.barResizeObserver.disconnect()
          }
          
          // 使用防抖避免 ResizeObserver loop 错误
          let resizeTimeout = null
          this.barResizeObserver = new ResizeObserver(() => {
            if (resizeTimeout) {
              clearTimeout(resizeTimeout)
            }
            resizeTimeout = setTimeout(() => {
              this.handleBarResize()
            }, 100)
          })
          
          this.barResizeObserver.observe(barDom)
        } else {
          // 降级方案：使用 window.resize 事件
          window.removeEventListener('resize', this.handleBarResize)
          window.addEventListener('resize', this.handleBarResize)
        }
      }
      
      window.addEventListener('resize', () => {
        if (this.barChart) {
          this.barChart.resize()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.center-map {
  height: 100%;
  background: url('~@/assets/images/柱状图容器的背景图.png') no-repeat center center;
  background-size: contain;
  background-position: center bottom;
}

.panel-box {
  width: 100%;
  height: 100%;
  background: url('~@/assets/images/地图的背景图.png') no-repeat center center;
  background-size: contain;
  background-position: top center;
  border-radius: 4px;
  position: relative;
}

.map-content {
  padding: 20px 0px 5px 0px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.map-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
  gap: 20px;
}

.tab-buttons {
  display: flex;
  gap: 15px;
  
  .tab-btn {
    padding: 0.3vh 2vh;
    background: rgba(79, 172, 254, 0.1);
    border: 1px solid #4facfe;
    color: #fff;
    cursor: pointer;
    border-radius: 20px;
    font-size: 13px;
    transition: all 0.3s;
    position: relative;
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(79, 172, 254, 0.3), transparent);
      transition: left 0.5s;
    }
    
    &.active {
      background: linear-gradient(135deg, #4facfe, #00f2fe);
      box-shadow: 0 0 15px rgba(79, 172, 254, 0.6);
      
      &::before {
        left: 100%;
      }
    }
    
    &:hover:not(.active) {
      background: rgba(79, 172, 254, 0.2);
      box-shadow: 0 0 10px rgba(79, 172, 254, 0.4);
    }
  }
}

.map-chart {
  flex: 1;
  width: 100%;
  min-height: 350px;
}

.map-legend {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin: 10px 0;
  
  .legend-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.45);
    
    .legend-icon {
      width: 12px;
      height: 12px;
      border-radius: 2px;
    }
  }
}

.bar-chart {
  width: 100%;
  height: 220px;
  padding: 10px;
}
</style>
